import { URL } from '../../config.js';
import {axios} from '../../handlers/RequestHandler';
import store from '../store';
import { tableRemove, tableUpdate } from './tableActions';
import Notification from '../../handlers/Notification';
import { FloatPrecision,setMin,setMax,setStack,toPaginate, utcToLocal } from './UtilsOperation';
import {
    COMPANY_ACCESS,
    DEFAULT_TIME_ZONE
} from '../../constants/general';
import { UNLIMITED_STOCK ,FLAG_ADMIN_CUSTOMIZABLE,DEFAULT_PRODUCTS_PAGE_SIZE } from '../../constants/general';

var clear = {
    picture_urls:[],
    name:"",
    price_e2:"",
    short_details:"",
    details:"",
    level:"",
    type:"",
    unit_config_visible:false,
    unit_config:null
}

const clearGood = () => {
    return (dispatch) => {
        dispatch({
            type: 'CLEAR_GOOD',
            good: clear,
            dropzoneFiles: [],
        })
    }
}

const showG = () => {
    return (dispatch,getState) => {
        return axios.get(`${URL}${getState().company.id}/goods`).then( (res) => {
            dispatch({
                type: 'FETCH_GOODS',
                goods: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_goods});
        });
    }
}
const searchGoods = (search) => {
    return (dispatch,getState) => {
        dispatch({type: 'FETCH_GOODS',goods: []})
        return axios.get(`${URL}${getState().company.id}/goods/search?q=${search}&limit=10&with=branch_group`).then( (res) => {
            dispatch({
                type: 'FETCH_GOODS',
                goods: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_goods});
        });
    }
}
const toggleCategoryItems = (id, isSelected, goodType) => {
    const new_id = id.split("-")[1];
    var url='';
    var category = '';
    var error = '';
    return ( dispatch , getState ) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})

        if(isSelected){
            url = `${URL}${getState().company.id}/branches/${getState().branch.id}/goods?limit=${DEFAULT_PRODUCTS_PAGE_SIZE}&good-type=flag 7,${goodType}`;
            category = '';
            error = getState().json_lang.custom_errors.retrieving_goods_list;
        }else{
            url = `${URL}${getState().company.id}/branches/${getState().branch.id}/branch-goods?limit=${DEFAULT_PRODUCTS_PAGE_SIZE}&category_id=${new_id}&has_stock=1`;
            category = new_id;
            error = getState().json_lang.custom_errors.update_categories_product;
        }
        return axios.get(`${url}`).then( (res) => {
            dispatch({
                type: 'FETCH_LIST_GOODS',
                goodsList: isSelected ? res.data : res.data.filter(elm => elm.type === parseInt(goodType, 10)),
                category: category,
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: error });
        });

    }
}

const getCustomCategoryWithProducts = (branch_id,category_id)=>{
    return (dispatch,getState) => {

        const { company } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL}${company.id}/branches/${branch_id}/branch-goods?limit=${DEFAULT_PRODUCTS_PAGE_SIZE}${ (category_id ? "&category_id="+category_id : "")}`).then((res) => {
            dispatch({
                type: 'FETCH_LIST_GOODS',
                goodsList: res.data.length && res.data[0].branch_goods
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: ""});
        });
    }
}



const getCategoryWithProducts = (category_id,stock,page=1)=>{
    return (dispatch,getState) => {
        //branches/44/branch-categories/goods?limit=0
        const { company, branch} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})

        return axios.get(`${URL}${company.id}/branches/${branch.id}/branch-goods?limit=${DEFAULT_PRODUCTS_PAGE_SIZE}&page=${page}${ (category_id ? `&category_id=${category_id}` : ``)}${ (stock? `&has_stock=${stock}` : ``)}`).then((res) => {
            dispatch({
                type: 'FETCH_LIST_GOODS',
                goodsList: res.data//.length && res.data[0].branch_goods //categoryFilter && categoryFilter.length > 0 ? categoryFilter[0].branch_goods : []
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: ""});
        });
    }
}

const searchQueryGoods = (query = "", goodType) => {
    let queryString = "";

    if(query)
        queryString = "?search=" + query + "&good-type=flag 7," + goodType;
    else if(!query)
        queryString = "?type=" + goodType;

    return (dispatch) => {
        axios.get(URL + store.getState().company.id + '/goods' + queryString )
        .then( (res) => {

            dispatch({
                type: 'AUTOCOMPLETE_GOODS',
                goods: res.data.data.filter(good => good.available === true)
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: ""});
        });
    }
}

const find = (id) => {
    /* xHACER: esto ya no es asi... revisar esta inicializacion con data vieja... y pasar el res.data directamente, pa ver donde se rompe */

    return (dispatch) => {
        return axios.get(URL + store.getState().company.id + '/goods/' + id).then( (res) => {
            console.log('goodsData',res)
            let goodsData = {
                id:res.data.id,
                picture_urls:res.data.picture_urls,
                vertical_picture_urls:res.data.vertical_picture_urls,
                name:res.data.name,
                price_e2:parseFloat(res.data.price_e2,10),
                short_details:res.data.short_details,
                details:res.data.details,
                type:res.data.type,
                eta:res.data.eta,
                sku:res.data.sku,
                available:res.data.available,
                quantity:res.data.quantity,
                notes_enabled:res.data.notes_enabled,
                quantity_unlimited:res.data.quantity === null ? true : false,
                flag_digital_types:0,
                eta_config_id:res.data.eta_config_id,
                eta_config: res.data.eta_config,
                featured_in_order: res.data.featured_in_order,
            }
            dispatch({
                type: 'FETCH_GOOD',
                good: goodsData
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: store.getState().json_lang.custom_errors.retrieving_goods});
        });
    }
}

const fetchGood = (id,materials,branchId) => {
    return (dispatch,getState) => {
		const { company, json_lang,branch } = getState();
        //const api_host = /*company.settings && company.settings.is_marketplace ? `/branches/${branch.id}/branch-goods`:*/`/goods`
        const api_host = /*company.settings.is_marketplace ?:`/goods`*/ `/branches/${branchId || branch.id}/goods`
        return axios.get(`${URL}${company.id}${api_host}/${id}${materials ? `?with=materials` : ""}`).then( (res) => {
            dispatch({
                type: 'FETCH_GOOD',
                good: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_goods});
        });
    }
}

const fetchGoodWithBranchGroup = (id) => {
    return (dispatch,getState) => {
        const { company, json_lang } = getState();
        return axios.get(`${URL}${company.id}/goods/${id}?with=branch_group`).then( (res) => {
            dispatch({
                type: 'FETCH_GOOD',
                good: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_goods});
        });
    }
}

const clearGoodWithBranchGroup  = () => {
    return (dispatch) => {
        dispatch({
            type: 'FETCH_GOOD',
            good: {}
        })
    }
}

const activePreloader = (id) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
    }
}

const fetchGoods = (goodType = null,stock,page=1,filterQuery= '', search = '', categoryId = null,featured = false, limit = DEFAULT_PRODUCTS_PAGE_SIZE) => {
    return (dispatch , getState) => {
		const { company, json_lang,branch } = getState();
        let categoryParam = categoryId ? `&category_id=${categoryId}` : ``;
        if(categoryId === "uncategory"){
            categoryParam = `&goodCategories=:has:0`;
        }

        //return false;
        let queryParams = `${search ? "&" : "?"}limit=${DEFAULT_PRODUCTS_PAGE_SIZE}&with=materials${goodType === 0 || goodType === 1 ? `&good-type=flag 7,${goodType}`: ''}&page=${page}${categoryParam}${stock ? `&has_stock=${stock}` : ``}${filterQuery}${featured ? `&is_featured=1` : ''}`
        let url_host = `${URL}${company.id}/branches/${branch.id}/branch-goods${search ? `/search?q=${search}` : ''}${queryParams}`;
        //!TODO: arreglar el search
        //*https://api-dev.dondemand.io/api/v3/companies/116/branch-groups/109/goods/search?q=Harina


        return axios.get(url_host).then( res => {
            let goods_arrays= null;
            if (!search) {
                goods_arrays = res.data;
            }else{
                goods_arrays = toPaginate(res.data, limit, 1)
            }
            dispatch({
                type: 'FETCH_LIST_GOODS',
                goodsList: goods_arrays
            })
        }).catch( err => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_goods_list});
        });
    }
}

const searchBranchGoods = (search, branchId = null) => {
    return (dispatch, getState) =>{
		const { company, branch } = getState();
        let url_host = `${URL}${company.id}/branches/${branchId || branch.id}/branch-goods/search?q=${encodeURIComponent(search)}`;
        return axios.get(url_host).then((res) => {
            dispatch({
                type: 'FETCH_GOODS',
                goods: res.data
            })
        })
    }
}

const fetchCompanyGoods = (query) => {

    return (dispatch , getState) => {

        const { company, json_lang } = getState();
        return axios.get(`${URL}${company.id}/goods/search?q=${query}`).then( res => {
            dispatch({
                type: 'FETCH_LIST_GOODS',
                goodsList: res.data
            })

        }).catch( err => {

            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});

            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_goods_list});
        });
    }
}
const fetchModalGoods = (branch_id) => {

    return (dispatch , getState) => {

        const { company, json_lang } = getState();
        dispatch({
            type: 'FETCH_LIST_GOODS',
            goodsList:[]
        })
        return axios.get(`${URL}${company.id}/branches/${ branch_id }/branch-goods?limit=10`).then( res => {
            dispatch({
                type: 'FETCH_LIST_GOODS',
                goodsList: res.data
            })

        }).catch( err => {

            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});

            else
                Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_goods_list});
        });
    }
}

const fetchModalGoodsgroup = (branch_id,page=1,query) => {
    return (dispatch , getState) => {
        const { company, json_lang } = getState();
        dispatch({
            type: 'FETCH_LIST_GOODS',
            goodsList:[]
        })
        return axios.get(`${URL}${company.id}/branch-groups/${branch_id}/goods?limit=10&with=branch_group&page=${page}${query ? `&name=ilike ${query}` :``}`).then( res => {
            console.log("fetchModalGoodsgroup",res.data)
            dispatch({
                type: 'FETCH_LIST_GOODS',
                goodsList: res.data
            })
        }).catch( err => {

            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title: err.title, msg: err.message});

            else
                Notification.show({ type: "error", title: err.title, msg: json_lang.custom_errors.retrieving_goods_list});
        });
    }
}

const clearGoodsgroup = () => {

    return (dispatch ) => {
        dispatch({
            type: 'FETCH_LIST_GOODS',
            goodsList:[]
        })
    }
}

const fetchUncatogiresGoods = (goodType = null,stock) => {

    return (dispatch , getState) => {

        const { company, json_lang,branch } = getState();
        const api_host = company.settings && company.settings.is_marketplace ? `/branches/${branch.id}/branch-goods?limit=${DEFAULT_PRODUCTS_PAGE_SIZE}&goodCategories=:has:0${stock?`&has_stock=${stock}`:``}`:`/goods`
        return axios.get(`${URL}${company.id}${api_host}${goodType === 0 || goodType === 1 ? '&good-type=flag 7,' + goodType : ''}`).then( res => {

                dispatch({
                    type: 'FETCH_LIST_GOODS',
                    goodsList: res && res.data
                })
            }).catch( err => {

                if(err.message && err.message !== 'generic')
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});

                else
                    Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_goods_list});
            });
    }
}

const fetchAvaliableGoods = (goodType = null) => {
    return (dispatch , getState) => {
		const { company, json_lang } = getState();
        var urlGoodType = goodType === 0 || goodType === 1 ? `&type=flag 7,${goodType}`: '';

        const api_host = `${URL}${company.id}/goods?limit=0&${urlGoodType}`; // available=1&with=good.allowedProviders

        return axios.get(api_host)

            .then( res => {
                dispatch({
                    type: 'FETCH_LIST_GOODS',
                    goodsList: res.data,
                    goodType:goodType
                })

            }).catch( err => {

                if(err.message && err.message !== 'generic')
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});

                else
                    Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_goods_list});
            });
    }
}

const displayListGoods = () => {
    return (dispatch , getState) => {
        return axios.get(`${URL}${getState().company.id}/goods?limit=0&available=1`).then(res => { // with=good.allowedProviders
                dispatch({
                    type: 'DISPLAY_LIST_GOODS',
                    goodsList: res.data
                })
            }).catch( err => {
                if(err.message && err.message !== 'generic')
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
                else
                    Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_goods_list});
            });
    }
}

const fetchArchivedGoods = () => {
    return (dispatch) => {
        axios.get(URL + store.getState().company.id + '/goods?limit=0&mode=deleted').then( (res) => {
            dispatch({
                type: 'FETCH_LIST_GOODS',
                goodsList: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: store.getState().json_lang.custom_errors.retrieving_goods });
        });
    }
}

const toggleData = (value,priceChanged) => {
    return (dispatch,getState) => {
        var data = {...getState().good}

        if( value.name === 'available' || value.name === 'quantity_unlimited' || value.name === 'notes_enabled' || value.name === 'is_combo'){
            data[value.name] = value.checked ;
            if( value.name === 'quantity_unlimited' ){
                data.quantity = data.quantity_unlimited === true ? '' : data.quantity;
            }
        }

        else if( value.name === 'picture_urls' ){

            if( data.picture_urls.length > 0 ) {
                var urls = data.picture_urls.filter( (item,i) => {
                    return (parseInt(value.data,10) !== i )
                })
                data.picture_urls = urls;
            }
        }

        else if(value.name === 'price_e2' || value.name === 'quantity' || value.name === 'eta'){
            data[value.name] = isNaN(value.data) ? data[value.name]:value.data ;
            if( value.name === 'price_e2' ){
                data.priceChanged = true
            }
        }

        else if( value.name === "list_type" ){
            data.type = value.checked ? parseInt(data.type,10)|16 : parseInt(data.type,10)&~16;
            data.list_type = value.checked ? 1 : 0;
        }
        else if( value.name === "digital_type" ){
            data.type = value.checked ? parseInt(data.type,10)|0x4 : parseInt(data.type,10)&~0x4;
            data.digital_type = value.checked ? 1 : 0;
        }

        else if( value.name === "flag_digital_types" ){
           // console.log("flag_digital_types",parseInt(value.data,10))
            data.type = (parseInt(data.type,10)&~0xff00)|parseInt(value.data,10);
            data.flag_digital_types = value.data;
        }

        //
        else if( value.name === "max_quantity" ){
            data[value.name] = parseInt(value.data,10);
        }
        else if( value.name === "enabled"){
            data.unit_config.enabled = value.checked;

        }
        else if( value.name === "weight_per_unit" || value.name === "min_quantity" || value.name === "step_quantity" || value.name === "display_mode" || value.name === "fraction" || value.name === "unit_name"){
            data.unit_config[value.name] = value.data;

        }
        else if( value.name === "unit_max_quantity"){
            data.unit_config.max_quantity = value.data;
        }
        else if( value.name === "max_quantity_unlimited"){
            data.unit_config.max_quantity_unlimited = value.checked;
            data.unit_config.max_quantity = "";
        }
        else if( value.name.split('picture_urls_order-').length > 1 ){
            let key2 = parseInt(value.name.split('picture_urls_order-')[1],10)
            if(parseInt(value.data,10) < data.picture_urls.length && value.data !== ""){
                let newOrder = [...data.picture_urls]
                newOrder[value.data]= data.picture_urls[key2]
                newOrder[key2]= data.picture_urls[value.data]
                data.picture_urls = newOrder
            }
        }
        else if( value.name.split('vertical_picture_order-').length > 1 ){
            let key2 = parseInt(value.name.split('vertical_picture_order-')[1],10)
            if(parseInt(value.data,10) < data.vertical_picture_urls.length && value.data !== ""){
                let newOrder = [...data.vertical_picture_urls]
                newOrder[value.data]= data.vertical_picture_urls[key2]
                newOrder[key2]= data.vertical_picture_urls[value.data]
                data.vertical_picture_urls = newOrder
            }
        }
        else{
            data[value.name] = value.data;
        }
       // console.log(" data.unit_config", data)
		dispatch({
		    type: 'FETCH_GOOD',
		    good: data
		})
    }
}

const update = () => {
    return ( dispatch , getState ) => {
        var data = getState().good;
            var good = new FormData();
            good.append('name', data.name)
            if(data.priceChanged){
                good.append('price_e2', data.price_e2*100 )
            }
            good.append('short_details', data.short_details?data.short_details:'n/a')
            good.append('details', data.details)
            good.append('level', 0)
            good.append('type', data.type ? data.type : 0)
            good.append('available', data.available === true? 1 : 0)
            good.append('sku', data.sku ? data.sku : "")
            good.append('eta', data.eta ? data.eta : "")

            if(data.quantity_unlimited === true ){
                good.append('quantity', UNLIMITED_STOCK )
            }else{
                good.append('quantity', parseInt(data.quantity,10) > 0 ? data.quantity : 0)
            }
            /*if(getState().dropzoneFiles.length){
                getState().dropzoneFiles.map( (file) => {
                    var block = file.split(";");
                    var contentType = block[0].split(":")[1];
                    var realData = block[1].split(",")[1];
                    var blob = b64toBlob(realData, contentType);
                    return  good.append('pictures[]',  blob )
                })
            }*/

            if(data.picture_urls.length > 0 ){
                data.picture_urls.map( (url) => {
                    return  good.append('picture_urls[]',  url )
                })
            }else{
                good.append('picture_urls[]', [] )
            }

            /*if(data.picture_urls.length === 0 && getState().dropzoneFiles.length === 0){
                good.append('picture_urls[]', [] )
            }*/


            dispatch({type: "WAIT_FOR_RESPONSE"});

            return axios.put(`${URL}${getState().company.id}/branches/${getState().branch.id}/branch-goods/${data.id}`,good  ).then( (res) => {
                Notification.show({type: "success", title: getState().json_lang.common.success , msg: getState().json_lang.custom_success.saved_successful});
                dispatch({
                    type: 'GOOD_UPDATE_SUCCESS',
                    goodsList:  tableUpdate(res, "goodsList"),
                    good: clear,
                });
            }).catch((err) => {
                if(err.message && err.message !== 'generic'){
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
                }
                else if (err.data.message === "in_service_locked"){
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:  getState().json_lang.custom_errors.in_service_locked });
                }
                else if (err.data.message === "bound_type"){
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "El producto pertenece a almenos una categoria de tipo lista"});
                }
                else if (err.data.message === "attached_service_skills"){
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Es necesario retirar las habilidades requeridas del Servicio"});
                }
                else{
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_goods });
                }
            });

    }
}

const updateGoodEta = (good_id,eta_id) => {
    return ( dispatch , getState ) => {
		const { good,branch} = getState();
        let updatedGood = {...good};
		updatedGood.eta_config_id = eta_id === 0 ? null : eta_id;

        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.patch(`${URL}${getState().company.id}/branches/${branch.id}/goods/${good_id}`,updatedGood ).then( (res) => {
            Notification.show({type: "success", title: getState().json_lang.common.success , msg: getState().json_lang.custom_success.saved_successful});

        }).catch((err) => {
            if(err.message && err.message !== 'generic'){
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            }
            else if (err.data.message === "in_service_locked"){
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:  getState().json_lang.custom_errors.in_service_locked });
            }
            else if (err.data.message === "bound_type"){
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "El producto pertenece a almenos una categoria de tipo lista"});
            }
            else if (err.data.message === "attached_service_skills"){
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Es necesario retirar las habilidades requeridas del Servicio"});
            }
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_goods });
            }
        });
    }
}


const checkAvailability =(data) =>{
    return (dispatch,getState) => {
        const { company, json_lang} = getState();
        var good = new FormData();
        good.append('available', data.available === true ? 0 : 1 )
        if(data.picture_urls.length > 0 ){
            data.picture_urls.map( (url) => {
                return  good.append('picture_urls[]',  url )
            })
        }

        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(URL+company.id + '/goods/'+data.good_id+'/categories?limit=0').then( (res) => {
            if(res.data.length>0){
                return axios.post(URL + company.id + '/goods/' + data.good_id ,good  ).then( (res) => {
                    Notification.show({type: "success", title:json_lang.common.success , msg: json_lang.custom_success.saved_successful});
                    dispatch({
                        type: 'GOOD_UPDATE_SUCCESS',
                        goodsList:  tableUpdate(res, "goodsList"),
                        good: clear,
                    });
                }).catch((err) => {
                    if(err.message && err.message !== 'generic'){
                        Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
                    }
                    else if (err.data.message === "in_service_locked"){
                        Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:  json_lang.custom_errors.in_service_locked });
                    }
                    else if(err.data.message === "missing_service_skills"){
                        Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Por favor anexe habilidades requeridas" });
                    }
                    else if(err.data.message === "matching_providers_not_found"){
                        Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "No tiene proveedores con las habilidades necesarias para hacer este servicio" });
                    }
                    else if(err.data.message === "no_stock"){
                        Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "El inventario de este producto es 0" });
                    }
                    else{
                        Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_goods });
                    }
                });
            }else{
                Notification.show({type: "warning", title:'datos incompletos', msg: 'por favor ingrese almenos 1 categoria'});
            }
        }).catch((err) => {
            if(err &&  err.data &&  err.data.message && err.data.message){
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.data.message});
            }
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_categories_product });
            }
        });
    }
}

const register = () => {
    return (dispatch,getState) => {
        let { company, json_lang,branch,good ,userHigherAccess} = getState();

        let goodData={
            name: good.name,
            short_details: good.short_details?good.short_details:'n/a',
            details: good.details ? good.details : "n/a",
            price_e2:parseFloat(FloatPrecision(good.price_e2*100)),
            type: good.type ? good.type : 0,
            available: 0,
            unit_config:null,
        }
        if(branch.branch_group.is_digital){
            goodData.type = branch.branch_group.is_digital ? parseInt(good.type,10)|0x4 : parseInt(good.type,10)&~0x4;
        }
        if(good.sku){
            goodData.sku=good.sku
        }
        if(good.unit){
            goodData.unit=good.unit
        }
        if(good.list_order){
            goodData.list_order=good.list_order
        }
        if(good.eta){
            goodData.eta=good.eta
        }

        if(good.quantity_unlimited === true ){
            goodData.quantity= UNLIMITED_STOCK
        }else{
            goodData.quantity= parseInt(good.quantity,10) > 0 ? good.quantity : 0
        }

        if(userHigherAccess === COMPANY_ACCESS){
            goodData.notes_enabled = good.notes_enabled ? good.notes_enabled : false
        }
        if(good.unit_config_visible === true){
            goodData.unit_config = {
                enabled:good.unit_config && good.unit_config.enabled,
                display_mode:good.unit_config && good.unit_config.display_mode,
                fraction:parseFloat(good.unit_config && good.unit_config.fraction),
                min_quantity: parseFloat(good.unit_config && good.unit_config.min_quantity),
                step_quantity: parseFloat(good.unit_config && good.unit_config.step_quantity),
                max_quantity: parseFloat(good.unit_config && good.unit_config.max_quantity),
                unit_name:good.unit_config && good.unit_config.unit_name,
                weight_per_unit:parseInt(good.unit_config && good.unit_config.weight_per_unit,10)
            }
        }

        if(good.max_quantity){
            goodData.max_quantity=good.max_quantity
        }
        if(good.limit_type){
            goodData.limit_type=good.limit_type
        }
        console.log("registerBranchGood",branch)
        dispatch({type: "WAIT_FOR_RESPONSE"});
        const api_host = company.settings && company.settings.is_marketplace ? `/branches/${branch.id}/goods`:`/goods`
        return axios.post(`${URL}${company.id}${api_host}`, goodData).then( (res) => {
            Notification.show({type: "success", title:json_lang.common.success, msg: getState().json_lang.custom_success.saved_successful_product});
            dispatch({
			type: 'REGISTER_GOOD',
                good: res.data,
                clear: clear,
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_goods });
        });
    }
}

const duplicateGood = (data) => {
    return (dispatch) => {
        var data = store.getState().good;
        var good = new FormData();
        good.append('name', data.name)
        good.append('price_e2', data.price_e2)
        good.append('short_details', data.short_details?data.short_details:'n/a')
        good.append('eta', data.eta)
        good.append('details', data.details)
        good.append('level', 0)
        good.append('type', data.type ? data.type : 0)
        good.append('available', data.available === true? 1 : 0)

        store.getState().dropzoneFiles.map( (file) => {
            return  good.append('pictures[]', file)
        })
        return axios.post(URL + store.getState().company.id + '/goods', good).then( (res) => {
            dispatch({
                type: 'REGISTER_GOOD',
                good: res.data,
                clear: clear,
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Hubo un error al duplicar producto"});
        });
    }
}

const destroy = (id) => {
    return (dispatch) => {
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.delete(URL + store.getState().company.id + '/goods/'+ id).then( (res) => {
            var succesful = store.getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg: store.getState().json_lang.custom_success.saved_successful});
            dispatch({
                type: 'GOOD_DELETED',
                goodsList:  tableRemove(res, "goodsList"),
                good: clear,
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: store.getState().json_lang.custom_errors.good_delete_failed });
        });
    }
}

const restoreGood = (id) => {
    return (dispatch) => {
        return axios.patch(URL + store.getState().company.id + '/goods/'+ id + '/restore').then( (res) => {
            var succesful = store.getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg: store.getState().json_lang.custom_success.saved_successful});
            dispatch({
                type: 'GOOD_RESTAURED',
                goodsList:  tableRemove(res, "goodsList"),
                good: clear,
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: store.getState().json_lang.custom_errors.retrieving_goods});
        });
    }
}

const togglepropertiesGood = (value, in_order = null) => {
    return (dispatch,getState) => {

        let name = value.name.split('-')[0];
        let id = parseInt(value.name.split('-')[1],10);
        let data = getState().propertiesGood.map( (property) => {
            if(property.pivot === undefined){
                property.pivot = {
                    property_id:id,
                    display_name:'',
                    options:0,
                }
            }

            if(property.pivot.mandatory === undefined){
                property.pivot.mandatory = false
            }
            if( property.id === id){

                if(name === 'display_name'){
                    property.pivot.display_name = value.data
                }
                if( name === 'options'){
                    property.pivot.options = ((property.pivot.options)&~0xfff)|value.data
                }
                if(name === 'mandatory'){
                    property.pivot.options = ((property.pivot.options & 0xF00000) !== 0) ? (property.pivot.options & ~0xF00000) : (property.pivot.options | 0x100000)
                }

                if(name === 'adminCustomizable'){
                    property.pivot.options = ((property.pivot.options & FLAG_ADMIN_CUSTOMIZABLE) !== 0) ? (property.pivot.options & ~FLAG_ADMIN_CUSTOMIZABLE) : (property.pivot.options | FLAG_ADMIN_CUSTOMIZABLE)
                }

                if(name === 'min'){
                    property.pivot.options =  setMin(value.data,property.pivot.options)

                }

                if(name === 'max'){
                    property.pivot.options = setMax(value.data,property.pivot.options)
                }
                if(name === 'stack'){
                    property.pivot.options = setStack(value.data,property.pivot.options)
                }
            }
            // console.log(variant)
            if (in_order !== null) {
                property.pivot.in_order = in_order
            }

            return property
        })

        dispatch({
            type: 'PROPERTIES_GOOD',
            propertiesGood: data,
            properties:getState().properties
        })
    }
}

const updatePropertiesGood = (id) => {
    return (dispatch,getState) => {
        return axios.get(URL + getState().company.id + '/properties/'+id).then( (res) => {
            if(id>0){
                var newRes = res.data;
                newRes.pivot={
                    property_id:res.data.id,
                    display_name:res.data.name,
                    options:res.data.type
                }
                var newdata = [
                    ...getState().propertiesGood,
                ]
                newdata.push(newRes);

                var propertiesUpdate = getState().properties.filter( (item) => {
                    return ( item.id !== id )
                })

                dispatch({
                    type: 'PROPERTIES_GOOD',
                    propertiesGood: newdata,
                    properties: propertiesUpdate
                });
            }

        }).catch((err) => {
            Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}

const savepropertiesGood = (id,good_id) => {
    var data = store.getState().propertiesGood.map( (property) => {
       if(property.pivot === undefined){
            property.pivot = {
                property_id:'',
                display_name:'',
                options:1024
            }
        }else{
            var optionValue= 1024
            if(property.pivot.options){
                optionValue = property.pivot.mandatory === true ? property.pivot.options | 0xF00000  : property.pivot.options
            }
            property.pivot = {
                property_id: property.pivot.property_id,
                display_name:property.pivot.display_name,
                options:optionValue
            }
        }
        return (property.pivot)
    })
    return (dispatch) => {
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.post(URL + store.getState().company.id + '/goods/'+good_id+'/properties', data).then( (res) => {
            var succesful = store.getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg: store.getState().json_lang.custom_success.saved_successful});
            dispatch({
                type: 'SAVE_PROPERTIES_GOOD',
                propertiesGood:  res.data
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Hubo un error al guardar variantes de un producto"});
        });
    }
}


const getGoodServiceSkills = (id) => {
    return (dispatch,getState) => {
        let data = [...getState().service_skill_groups]
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL}${getState().company.id}/goods/${id}/service-skills`).then( (res) => {

            let enabled = {}

            res.data.forEach( (e) => {
                enabled[e.id] = true
            })

            let activeSkills = data.filter( (group) => {
                return group.skills.length > 0
            }).map( (group) => {
                group.skills = group.skills.map( (skill) => {
                    skill.active = enabled[skill.id] || false
                    return skill;
                });
                return group;
            })
            /*let activeSkills =[]
            data.forEach( (data) => {
                if( data.skills.length > 0 ){
                    var test={
                        name:data.name,
                        skills:[]
                    }
                    data.skills.forEach( (skill) => {
                        let skillTest ={
                            id:skill.id,
                            name:skill.name,
                            active:false
                        }
                        res.data.forEach(  (res) => {
                            if(res.id === skill.id){
                                skillTest.active = true
                            }
                        })
                        test.skills.push(skillTest)
                    })
                    if(test.skills.length > 0){
                        activeSkills.push(test)
                    }
                }
            })*/
            dispatch({
                type: 'LIST_GOODSERVICE_SKILL_GROUPS',
                goodServiceSkills: activeSkills
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Hubo un error al guardar variantes de un producto"});
        });
    }
}

const getGoodTags = (id) => {
    return (dispatch,getState) => {
        let data = [...getState().good_tag_groups]
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL}${getState().company.id}/goods/${id}/good-tags`).then( (res) => {
            let enabled = {}
            res.data.forEach( (e) => {
                enabled[e.id] = true
            })

            let activeTags = data.filter( (group) => {
                return group.tags.length > 0
            }).map( (group) => {
                group.tags = group.tags.map( (tag) => {
                    tag.active = ( enabled && enabled[tag.id] ) || false
                    return tag;
                });
                return group;
            })

            dispatch({
                type: 'LIST_GOOD_TAG_GROUPS',
                good_tag_groups: activeTags
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Hubo un error al guardar variantes de un producto"});
        });
    }
}

const toggleGoodTags = (value) => {
    return (dispatch,getState) => {
        let name = value.name.split('-')
        let newdata =[...getState().good_tag_groups];

        newdata[name[1]].tags[name[2]].active = !newdata[name[1]].tags[name[2]].active
        dispatch({
            type: 'LIST_GOOD_TAG_GROUPS',
            good_tag_groups: newdata
        })
    }
}
const clearGoodTags = () => {
    return (dispatch,getState) => {
        dispatch({
            type: 'LIST_GOOD_TAG_GROUPS',
            good_tag_groups: []
        });
    }
}
const getGoodServiceSkillsDetails = (id) => {
    return (dispatch,getState) => {
        let data = [...getState().service_skill_groups]
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL}${getState().company.id}/goods/${id}/service-skills`).then( (res) => {
            let enabled = {}

            res.data.forEach( (e) => {
                enabled[e.id] = true
            })

            let activeSkills = data.filter( (group) => {
                return group.skills.length > 0
            }).map( (group) => {
                group.skills = group.skills.filter( (skill) => {
                    return enabled[skill.id] || false
                });
                return group;
            })
            dispatch({
                type: 'LIST_GOODSERVICE_SKILL_GROUPS',
                goodServiceSkills: activeSkills
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Hubo un error al guardar variantes de un producto"});
        });
    }
}

const clearGoodServiceSkills = () => {
    return (dispatch,getState) => {
        dispatch({
            type: 'LIST_GOODSERVICE_SKILL_GROUPS',
            goodServiceSkills: []
        });
    }
}

const toggleGoodServiceSkillGroup = (value) => {
    return (dispatch,getState) => {
        let name = value.name.split('-')
        let newdata =[...getState().goodServiceSkills];

        newdata[name[1]].skills[name[2]].active = !newdata[name[1]].skills[name[2]].active
        dispatch({
            type: 'LIST_GOODSERVICE_SKILL_GROUPS',
            goodServiceSkills: newdata
        });
    }
}

const attachToogleServiceSkills = (id) => {
    return (dispatch,getState) => {
        var attachData =[]
        getState().goodServiceSkills.forEach( (goodServiceSkills) => {
            goodServiceSkills.skills.forEach( (skill) => {
                if(skill.active=== true){ attachData.push(skill.id) }
            })
        })
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.put(`${URL}${getState().company.id}/goods/${id}/service-skills`,attachData).then( (res) => {
            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg:getState().json_lang.custom_success.saved_successful
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Hubo un error al guardar variantes de un producto"});
        });
    }
}


const attachToogleGoodsTags = (id) => {
    return (dispatch,getState) => {
        var attachData =[]
        getState().good_tag_groups.forEach( (good_tag_group) => {
            good_tag_group.tags.forEach( (tag) => {
                if(tag.active=== true){ attachData.push(tag.id) }
            })
        })
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.put(`${URL}${getState().company.id}/goods/${id}/good-tags`,attachData).then( (res) => {
            Notification.show({
                type: "success",
                title:getState().json_lang.common.success,
                msg:getState().json_lang.custom_success.saved_successful
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Hubo un error al guardar variantes de un producto"});
        });
    }
}

const getGoodTagGroups = () => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL}${getState().company.id}/good-tag-groups?with_tags=1`).then( (res) => {
            dispatch({
                type: 'LIST_GOOD_TAG_GROUPS',
                good_tag_groups: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: 'Error al buscar habilidades requeridas de los productos' });
        });
    }
}

const addGoodTagGroups = () => {
    return (dispatch, getState) => {
        var newData = { name: getState().new_good_tag_groups }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(`${URL}${getState().company.id}/good-tag-groups`,newData).then( (res) => {

            let new_good_tag_groups = [];
            res.data.tags = [];
            new_good_tag_groups.push(res.data);
            let update_data = new_good_tag_groups.concat( getState().good_tag_groups );
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});
            dispatch({
                type: 'LIST_GOOD_TAG_GROUPS',
                good_tag_groups: update_data
            })
        }).catch((err) => {
            if(err.data.message)
               Notification.show({type: "error", title: 'Error', msg: getState().json_lang.custom_errors[err.data.message] });
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:"" });
        });
    }
}

const toggleNewGoodTagGroups = (value) => {
    return (dispatch,getState) => {
        let name = value.name.split('-')
        if(name.length > 1){
            var update_data=getState().good_tag_groups.map( (good_tag_group,key) => {
                if(key===parseInt(name[1],10) ){
                    if(name[0] === 'name' || name[0] === 'new_name' ){
                        good_tag_group[name[0]] = value.data;
                    }else{
                        good_tag_group.tags[name[2]].name = value.data
                    }
                }
                return good_tag_group;
            })
            dispatch({
                type: 'LIST_GOOD_TAG_GROUPS',
                good_tag_groups: update_data
            })
        }else{
            var data = getState().new_good_tag_groups = value.data;
            dispatch({
                type: 'NEW_GOOD_TAG_GROUPS',
                new_good_tag_groups: data
            })
        }
    }
}

const deleteGoodTagGroup = (id) => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.delete(`${URL}${getState().company.id}/good-tag-groups/${id}`).then( (res) => {


            let update_data=getState().good_tag_groups.filter( (tag_group,key) => {
                return (tag_group.id !== parseInt(res.data.id,10))
            })

            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.delete_successful});
            update_data.sort()
            dispatch({
                type: 'LIST_GOOD_TAG_GROUPS',
                good_tag_groups: update_data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic'){
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            }else if (err.data.message){
                Notification.show({type: "error", title: 'Error', msg: getState().json_lang.custom_errors[err.data.message] });
            }else{
                Notification.show({type: "error", title: 'Error', msg: '' });
            }
        });
    }
}

const editGoodTagGroup = (id) => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})

        let data = getState().good_tag_groups.find( (tag_group,key) => { return tag_group.id === parseInt( id,10 ) })

        return axios.patch(`${URL}${getState().company.id}/good-tag-groups/${id}`,data).then( (res) => {
            let update_data=getState().good_tag_groups.map( (tag_group,key) => {
                if(tag_group.id === parseInt(res.data.id,10)){ tag_group.reason = res.data.reason }
                return tag_group;
            })
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.delete_successful});
            dispatch({
                type: 'LIST_GOOD_TAG_GROUPS',
                good_tag_groups: update_data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_restore_failed });
        });
    }
}

const addTag = (id) => {
    return (dispatch, getState) => {
        let newData = getState().good_tag_groups.find( (good_tag_group,key) => { return good_tag_group.id === parseInt( id,10 ) })
        dispatch({type: "WAIT_FOR_RESPONSE"})
        var tag = { name: newData.new_name }
        return axios.post(`${URL}${getState().company.id}/good-tag-groups/${id}/good-tags`,tag).then( (res) => {
            let update_data = getState().good_tag_groups.map( (good_tag_group,key) => {
                if(good_tag_group.id === parseInt( id,10 )){
                    good_tag_group.tags = good_tag_group.tags.concat(res.data)
                    good_tag_group.new_name =''
                }
                return good_tag_group
            })
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});
            dispatch({
                type: 'LIST_GOOD_TAG_GROUPS',
                good_tag_groups: update_data
            })
        }).catch((err) => {
            console.log("err.data.message",err.data.message)
            if(err.data.message)
               Notification.show({type: "error", title: 'Error', msg: getState().json_lang.custom_errors[err.data.message] });
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_restore_failed });
        });
    }
}

const editTag= (id,tag_id) => {
    return (dispatch, getState) => {
        let newData = getState().good_tag_groups.find( (good_tag_group,key) => { return good_tag_group.id === parseInt( tag_id,10 ) })
        let editedTag = newData.tags.find( (tag,key) => { return tag.id === parseInt( id,10 ) });
        dispatch({type: "WAIT_FOR_RESPONSE"})
        var tag = { name: editedTag.name }
        return axios.patch(`${URL}${getState().company.id}/good-tags/${id}`,tag).then( (res) => {
            /*let update_data = getState().good_tag_groups.map( (good_tag_group,key) => {
                if(good_tag_group.id === parseInt( id,10 )){
                    good_tag_group.tags = good_tag_group.tags.concat(res.data)
                    good_tag_group.new_name =''
                }
                return good_tag_group
            })
            dispatch({
                type: 'LIST_GOOD_TAG_GROUPS',
                good_tag_groups: update_data
            })

            */

            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});

        }).catch((err) => {
			if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Hubo un error al editar la etiqueta"});
        });
    }
}

const removeTag = (id,tag_id) => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.delete(`${URL}${getState().company.id}/good-tags/${id}`).then( (res) => {
            let update_data = [...getState().good_tag_groups]
            update_data.map( (tag_group,key) => {
                if(parseInt(tag_group.id,10 ) === parseInt( tag_id,10 )){
                    tag_group.tags = tag_group.tags.filter( (tag,key) => {
                        return parseInt(tag.id,10) !== parseInt(id,10)
                    })
                }
                return tag_group
            })

            dispatch({
                type: 'LIST_GOOD_TAG_GROUPS',
                good_tag_groups: update_data
            })
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});

        }).catch((err) => {
            if(err.message && err.message !== 'generic'){
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            }else if (err.data.message){
                Notification.show({type: "error", title: 'Error', msg: getState().json_lang.custom_errors[err.data.message] });
            }else{
                Notification.show({type: "error", title: 'Error', msg: '' });
            }
        });
    }
}
const isUploadingExcel = () => {
    return (dispatch, getState) => {
        let { isUploadingExcel } = getState();
        dispatch({
            type: 'IS_UPLOADING_EXCEL',
            isUploadingExcel: !isUploadingExcel
        })
    }
}

const fetchFeaturedProducts = (page = 1, search = "") => {
    return (dispatch,getState) => {
        axios.get(`${URL+getState().company.id}/good-sections?page=${page}${search ? `&name=ilike ${encodeURIComponent(search)}` :``}`).then( (res) => {
            dispatch({
                type: 'FEATURED_GOODS',
                featuredGoods: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: ""});
        });
    }
}

const findFeaturedProduct = (id) => {
    return (dispatch,getState) => {
        const { company } = getState();
        return axios.get(`${URL+company.id}/good-sections/${id}?with=goods.branch_group`).then( (res) => {
            res.data.good_ids = res.data.goods.map( (item,key) =>{
                return item.id
            });
            res.data.hour_from = res.data.hour_from
                ? utcToLocal(res.data.hour_from, "HH:mm")
                : "";

            res.data.hour_to = res.data.hour_to
                ? utcToLocal(res.data.hour_to, "HH:mm")
                : "";


            dispatch({
                type: 'FEATURED_GOOD',
                featuredGood: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: ""});
        });
    }
}

const toggleData4 = (value) => {
    return (dispatch,getState) => {
        var data = {...getState().featuredGood}

        if(value.name === 'use_date_configuration'){
            data.date_from = value.checked ? value.date_from : null;
            data.date_to = value.checked ? value.date_to : null;
        } else if( value.name === 'is_featured' || value.name.startsWith("day")){
            data[value.name] = value.checked;
        } else{
            data[value.name] = value.data;
        }
       
		dispatch({
		    type: 'FEATURED_GOOD',
		    featuredGood: data
		})
    }
}

const storeFeaturedProduct = (id) => {
    return (dispatch,getState) => {
        const { company, json_lang,featuredGoods,featuredGood } = getState();
        var data = {...featuredGood}
        data.tz = company.time_zone_offset || DEFAULT_TIME_ZONE,
        data.good_ids = data.goods.map( (item,key) =>{
            return item.id
        })
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(`${URL+company.id}/good-sections`,data).then( (res) => {

            Notification.show({
                type: "success",
                title:json_lang.common.success,
                msg:json_lang.custom_success.saved_successful
            });

            let newData = {...featuredGoods}
            let updateEtaConfigData = newData.data.concat(res.data)
            newData.data= updateEtaConfigData;

            dispatch({
                type: 'FEATURED_GOODS',
                featuredGoods: newData
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: ""});
        });
    }
}
const updateFeaturedProduct = (id) => {
    return (dispatch,getState) => {
        const { company,json_lang,featuredGoods,featuredGood } = getState();
        var data = {...featuredGood}
        data.tz = company.time_zone_offset || DEFAULT_TIME_ZONE,
        data.good_ids = data.goods.map( (item,key) =>{
            return item.id
        })
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL+company.id}/good-sections/${id}`,data).then( (res) => {
            Notification.show({
                type: "success",
                title:json_lang.common.success,
                msg: json_lang.custom_success.saved_successful
            });
            let newData = {...featuredGoods}
            let update = newData.data.map( (item,key) => {

                if(item.id === res.data.id){
                    item = res.data
                }
                return item
            })
            newData.data= update;
            dispatch({
                type: 'FEATURED_GOODS',
                featuredGoods: newData
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: ""});
        });
    }
}

const enableFeaturedProduct = (id,valor) => {
    console.log(id,valor)
    return (dispatch,getState) => {
        const { company,json_lang,featuredGoods } = getState();
        var data = {
            enabled:valor
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        axios.patch(`${URL+company.id}/good-sections/${id}`,data).then( (res) => {
            Notification.show({
                type: "success",
                title:json_lang.common.success,
                msg: json_lang.custom_success.saved_successful
            });
            let newData = {...featuredGoods}
            let update = newData.data.map( (item,key) => {

                if(item.id === res.data.id){
                    item = res.data
                }
                return item
            })
            newData.data= update;
            dispatch({
                type: 'FEATURED_GOODS',
                featuredGoods: newData
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: ""});
        });
    }
}
const deleteFeaturedProduct = (id) => {
    return (dispatch,getState) => {
        const { featuredGoods } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        axios.delete(`${URL+getState().company.id}/good-sections/${id}`).then( (res) => {
            let newData = {...featuredGoods}
            let update = newData.data.filter(elm => elm.id !== parseInt(id, 10))
            newData.data= update;
            dispatch({
                type: 'FEATURED_GOODS',
                featuredGoods: newData
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: ""});
        });
    }
}
const clearFeaturedProduct = () => {
	return (dispatch) => {
		let config={
			name:"",
			in_order:"",
			is_featured:false
		}

		dispatch({
            type: 'FEATURED_GOOD',
            featuredGood: config
        })
	}
}

const dettachFeaturedProduct = (id) => {
    return (dispatch,getState) => {
		const { featuredGood } = getState();
        var data = { ...featuredGood }

        let update = data.goods.filter(typeId => parseInt(typeId.id,10) !== parseInt(id,10));
        console.log("featuredGood",data.goods,id,update)
        data.goods =  update
        dispatch({
            type: 'FEATURED_GOOD',
            featuredGood: data
        })
    }
}

const attachFeaturedProduct = (item) => {
    return (dispatch,getState) => {
		const { featuredGood } = getState();
        var data = { ...featuredGood }
        if(!data.goods){
            data.goods=[]
        }
        let update = data.goods.concat(item)
        if(data.goods){
            data.goods  = update
        }
        dispatch({
            type: 'FEATURED_GOOD',
            featuredGood: data
        })
    }
}

const getQueryImages = (goodId) => {
    return (dispatch,getState) => {
        const { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL+company.id}/goods/${goodId}/query-images`).then(res => {
            dispatch({
                type: "GET_QUERY_IMAGES",
                queryImages: res.data
            })
        })
    }
}
const clearQueryImages = () => {
    return (dispatch) => {
        dispatch({
            type: "GET_QUERY_IMAGES",
            queryImages: []
        })
    }
}

export {
    attachFeaturedProduct,
    searchGoods,
    searchBranchGoods,
    dettachFeaturedProduct,
    clearFeaturedProduct,
    deleteFeaturedProduct,
    storeFeaturedProduct,
    updateFeaturedProduct,
    toggleData4,
    fetchFeaturedProducts,
    findFeaturedProduct,
    updateGoodEta,
    isUploadingExcel,
    clearGoodWithBranchGroup,
    fetchGoodWithBranchGroup,
    activePreloader,
    //registerBranchGroup,
    getCategoryWithProducts,
    displayListGoods,
    attachToogleGoodsTags,
    clearGoodTags,
    toggleGoodTags,
    getGoodTags,
    removeTag,
    editTag,
    addTag,
    editGoodTagGroup,
    deleteGoodTagGroup,
    addGoodTagGroups,
    toggleNewGoodTagGroups,
    getGoodTagGroups,
    clearGoodServiceSkills,
    showG,
    toggleCategoryItems,
    toggleData,
    restoreGood,
    searchQueryGoods,
    update,
    register,
    fetchArchivedGoods,
    duplicateGood,
    find,
    fetchGood,
    fetchGoods,
    destroy,
    updatePropertiesGood,
    togglepropertiesGood,
    savepropertiesGood,
    clearGood,
    checkAvailability,
    fetchAvaliableGoods,
    getGoodServiceSkills,
    toggleGoodServiceSkillGroup,
    attachToogleServiceSkills,
    getGoodServiceSkillsDetails,
    fetchUncatogiresGoods,
    fetchModalGoods,
    fetchCompanyGoods,
    getCustomCategoryWithProducts,
    fetchModalGoodsgroup,
    clearGoodsgroup,
    enableFeaturedProduct,
    getQueryImages,
    clearQueryImages
};




// WEBPACK FOOTER //
// ./src/store/actions/goodsActions.js